import { Component } from '@angular/core';
import { DynamicFormDto } from '../../../service/dto';
import { ActivatedRoute, Router } from '@angular/router';
import { FormResult } from '../../../components/dynamic-form/dynamic-form.component';
import { HttpBankService } from '../../../service/http-bank.service';

@Component({
  selector: 'app-bank-form',
  standalone: false,
  templateUrl: './bank-form.component.html',
  styleUrl: './bank-form.component.scss'
})
export class BankFormComponent {
	data?: DynamicFormDto;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private httpService: HttpBankService) { }

	ngOnInit(): void {
		const id = this.activatedRoute.paramMap.subscribe(paramMap => {
			const id = paramMap.get('id');
			if (id) {
				this.httpService.get(+id).subscribe(result => {
					this.data = result;
				});
			} else {
				this.httpService.getForm().subscribe(result => {
					this.data = result;
				});
			}
		});
	}
	doHandleResult(input: FormResult){
		if(input.type == 'Cancel'){
			this.router.navigate(['/bank','list']);
			return;
		}
		(this.data?.id ? (this.httpService.edit(this.data.id, input.data)) : (this.httpService.create(input.data))).subscribe(result => {
			this.router.navigate(['/bank','list']);
		});
	}
}
